export const GET_TRANSACTION = 'CITIZEN_ID/get_transaction';
export const APPROVE_TRANSACTION = 'CITIZEN_ID/approve_transaction';
export const REJECT_TRANSACTION = 'CITIZEN_ID/reject_transaction';
export const UPDATE_TRANSACTION = 'CITIZEN_ID/update_transaction';
export const SHOW_TRANSACTION = 'CITIZEN_ID/show_transaction';
export const START_ASSESSMENT = 'CITIZEN_ID/start_assessment';
export const GET_SETTINGS = 'CITIZEN_ID/get_settings';
export const UPDATE_TEST_STATUS = 'CITIZEN_ID/update_health_status';
export const CEDULA_URI =
  'api/v1/administrators/transaction_histories/cedula/{id}/generate';
export const TAG_AS_PRINTED_TRANSACTION = 'CITIZEN_ID/tag_as_printed';
export const ASSESS_RECEIPT = 'BIRTH_CERTIFICATES/assess_receipt';
export const CITIZEN_ID_URI_GENERATE = 
  'api/v1/administrators/residency_applications/{id}/generate';
  
  export const GENERATE_USERNAME = 'CITIZEN/generate_username';

export const DEPENDENCIES = {
  health_certificate_amount: {
    label: 'Health Certificate',
  },
  occupational_permit_amount: {
    label: 'Occupational Permit',
  },
  card_type: {
    label: 'CARD TYPE',
  },
  stool_amount: {
    label: 'Stool',
  },
  sputum_amount: {
    label: 'Sputum',
  },
  drug_test_amount: {
    label: 'Drug Test',
  },
  rpr_syphilis_amount: {
    label: 'RPR Syphilis',
  },
  gram_stain: {
    label: 'Gram Stain',
  },
};

export const FORM_DATA = {
  is_resident: 1,
  first_name: "",
  middle_name: "",
  last_name: "",
  mobile_number: "",
  email: "",
  photo: "",
  region_code: "",
  region_name: "",
  province_code: "",
  province_name: "",
  municipality_code: "",
  municipality_name: "",
  barangay_code: "",
  barangay_name: "",
  street: "",
  gender: "",
  place_of_birth_region_code: "",
  place_of_birth_province_code: "",
  place_of_birth_municipality_code: "",
  place_of_birth_region_name: "",
  place_of_birth_province_name: "",
  place_of_birth_municipality_name: "",
  birth_date: "",
  civil_status: "",
  extension_name: "",
  mother_maiden_last_name: "",
  mother_maiden_middle_name: "",
  mother_maiden_first_name: "",
  spouse_last_name: "",
  spouse_middle_name: "",
  spouse_first_name: "",
  spouse_mobile_number: "",
  father_last_name: "",
  father_middle_name: "",
  father_first_name: "",
  telephone_number: "",
  height: "",
  weight: "",
  complexion: "",
  highest_educational_attainment: "",
  citizenship_code: "",
  citizenship_name: "",
  institution_code: "",
  institution_name: "",
  tin_number: "",
  sss_id_number: "",
  philhealth_id_number: "",
  gsis_id_number: "",
  pagibig_id_number: "",
  is_voter: 0,
  user_id: "",
  login_pin: "",
  proof_of_residency_url: "",
};

export const CREATE_CITIZEN = 'CITIZEN/create_citizen';
export const UPDATE_CITIZEN = 'CITIZEN/update_citizen';
export const GET_REGION = 'CITIZEN/get_regions';
export const GET_PROVINCE = 'CITIZEN/get_provinces';
export const GET_MUNICIPALITIES = 'CITIZEN/get_municipalities';
export const GET_BARANGAYS = 'CITIZEN/get_barangays';

export const EXTENSION_NAMES = [
  { label: 'N/A', value: '' },
  { label: 'JR.', value: 'JR.' },
  { label: 'SR.', value: 'SR.' },
  { label: 'II', value: 'II' },
  { label: 'III', value: 'III' },
  { label: 'IV', value: 'IV' },
  { label: 'V', value: 'V' },
  { label: 'VI', value: 'VI' },
  { label: 'VII', value: 'VII' },
  { label: 'VIII', value: 'VIII' },
  { label: 'IX', value: 'IX' },
  { label: 'X', value: 'X' },
];

export const HIGHEST_EDUCATIONAL_ATTAINMENT = [
  {
    label: 'No Grade Completed',
    value: 'No Grade Completed',
  },
  {
    label: 'Preschool',
    value: 'Preschool',
  },
  {
    label: 'Elementary Undergraduate',
    value: 'Elementary Undergraduate',
  },
  {
    label: 'Elementary Graduate',
    value: 'Elementary Graduate',
  },
  {
    label: 'ALS Elementary',
    value: 'ALS Elementary',
  },
  {
    label: 'SPED Elementary',
    value: 'SPED Elementary',
  },
  {
    label: 'High School Undergraduate',
    value: 'High School Undergraduate',
  },
  {
    label: 'ALS Secondary',
    value: 'ALS Secondary',
  },
  {
    label: 'SPED Secondary',
    value: 'SPED Secondary',
  },
  {
    label: 'High School Graduate',
    value: 'High School Graduate',
  },
  {
    label: 'College Undergraduate',
    value: 'College Undergraduate',
  },
  {
    label: 'Post Secondary',
    value: 'Post Secondary',
  },
  {
    label: 'Post Secondary Graduate',
    value: 'Post Secondary Graduate',
  },
  {
    label: 'College Graduate',
    value: 'College Graduate',
  },
  {
    label: 'Post Baccalaureate',
    value: 'Post Baccalaureate',
  },
  {
    label: "Master's/PhD graduate",
    value: "Master's/PhD graduate",
  },
  {
    label: 'Not Reported',
    value: 'Not Reported',
  },
];

export const CIVIL_STATUSES = [
  {
    label: 'SINGLE',
    value: 'SINGLE',
  },
  {
    label: 'MARRIED',
    value: 'MARRIED',
  },
  {
    label: 'DIVORCED',
    value: 'DIVORCED',
  },
  {
    label: 'WIDOW',
    value: 'WIDOW',
  },
];

export const GENDERS = [
  { label: 'FEMALE', value: 'FEMALE' },
  { label: 'MALE', value: 'MALE' },
];
